import { render, staticRenderFns } from "./DetailChapter.vue?vue&type=template&id=69980f8a&lang=html"
import script from "./DetailChapter.vue?vue&type=script&lang=js"
export * from "./DetailChapter.vue?vue&type=script&lang=js"
import style0 from "./DetailChapter.vue?vue&type=style&index=0&id=69980f8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports